import { render, staticRenderFns } from "./MessagesNavbar.vue?vue&type=template&id=723b5e4e&scoped=true&"
import script from "./MessagesNavbar.vue?vue&type=script&lang=js&"
export * from "./MessagesNavbar.vue?vue&type=script&lang=js&"
import style0 from "./MessagesNavbar.vue?vue&type=style&index=0&id=723b5e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723b5e4e",
  null
  
)

export default component.exports